/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export const GET_APPLICATION_PERMISSIONS = 'uiActionTypes/GET_APPLICATION_PERMISSIONS';
export const GET_APPLICATION_PERMISSIONS_SUCCESS = 'uiActionTypes/GET_APPLICATION_PERMISSIONS_SUCCESS';
export const GET_APPLICATION_PERMISSIONS_FAILURE = 'uiActionTypes/GET_APPLICATION_PERMISSIONS_FAILURE';
export const UPDATE_CURRENT_PERMISSION = 'uiActionTypes/UPDATE_CURRENT_PERMISSION';

export interface GetApplicationPermissions {
  type: typeof GET_APPLICATION_PERMISSIONS;
  payload?:any,
}

export interface GetApplicationPermissionsSuccess {
  type: typeof GET_APPLICATION_PERMISSIONS_SUCCESS;
  payload?:any;
}

export interface GetApplicationPermissionsFailure {
  type: typeof GET_APPLICATION_PERMISSIONS_FAILURE;
  payload?:any;
}
